import { ReactNode } from 'react';
import { useGeoRestriction } from '@/hooks/useGeoRestriction';

interface GeoBlockGateProps {
  children: ReactNode;
}

export default function GeoBlockGate({ children }: GeoBlockGateProps) {
  const { status, ip, country } = useGeoRestriction();

  if (status === 'checking') {
    return <div className="min-h-screen w-full bg-background-50" aria-busy="true" />;
  }

  if (status === 'blocked') {
    return (
      <div className="min-h-screen w-full bg-background-50 flex items-center justify-center px-6">
        <div className="max-w-md w-full text-center">
          <div className="mx-auto mb-6 w-14 h-14 flex items-center justify-center rounded-full bg-background-100">
            <i className="ri-map-pin-line text-2xl text-foreground-600" />
          </div>
          <h1 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
            This website is not available in your region.
          </h1>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            We&apos;re sorry for the inconvenience. Access to this site is currently restricted in
            your location.
          </p>
          <div className="mt-6 pt-5 border-t border-background-200 text-xs text-foreground-600 space-y-1">
            <p>
              <span className="text-foreground-950 font-medium">Detected IP:</span>{' '}
              {ip ?? 'unknown'}
            </p>
            <p>
              <span className="text-foreground-950 font-medium">Region:</span>{' '}
              {country ?? 'unknown'}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}